export default __webpack_public_path__ + "static/media/mconferences1.faa3492a.jpg";